import Component from "../abstracts/Component";
import { Matchmq } from "../utils/ResolutionHandler";
import { algoliaClickAfterSearch, algoliaAddToCart, storeAlgoliaAttributes } from "../utils/algoliaTrackings";

export default class TrackingComponent extends Component {

  get SELECTORS() {
    return {
      dataTracking: '[data-tracking-action]',
      fitersInput: '.js-filters-checkbox',
      trackingPayload: '[data-tracking-payload]',
      cartPage: '.t-cart',
      O2OCCSearchInput: '#sl__search__input',
      recommendationEngineCarouselId: 'recommendation-engine-container-SF',
      dataAlgoliaSearch: '[data-algolia-search]',
    }
  }

  get trackingLabel(){
    return {
    NEW_ARRIVALS:"new_arrivals",
    OUR_FAVORITES:"our_favorites",
    PRICE_ASC:"price_asc",
    PRICE_DESC:"price_desc",
    REC_FOR_YOU:"rec_for_you",
    SALES:"sales",
    SOLR_SORTING:"solr_sorting",
    T2SELL_SORTING:"t2s_sorting",
    ALGOLIA_SORTING:"rec_for_you"
    }
  }

  // retrieve object/sub-object identified by [data-tracking-payload] attribute and parse them with .data() method
  // to retriieve product JSON
  getTrackingPayloadData(el, list) {
    let elements;

    if (list == true) {
      elements = $(el).find(this.SELECTORS.trackingPayload);
    } else {
      elements = $(el).closest(this.SELECTORS.dataTracking).find(this.SELECTORS.trackingPayload);
    }

    let products = [];
    elements.each(function () {
      products.push($(this).data());
    });
    return products;
  }

  getSortTypeTracking(sortValue) {
      if (!sortValue) {
          return '';
      }

      if (sortValue.startsWith('rank')) {
          return this.trackingLabel.REC_FOR_YOU;
      }

      switch (sortValue) {
          case 'new-arrival':
              return this.trackingLabel.NEW_ARRIVALS;
          case 'price-asc':
          case 'price-asc-sale':
              return this.trackingLabel.PRICE_ASC;
          case 'price-desc':
          case 'price-desc-sale':
              return this.trackingLabel.PRICE_DESC;
          case 'sale':
              return this.trackingLabel.SALES;
          case 'topRated':
          case 'target2sell':
              return this.trackingLabel.OUR_FAVORITES;
          case 'personalization':
            return this.trackingLabel.ALGOLIA_SORTING;
          default:
              return '';
      }
  }

  constructor() {
    super();
    this.actions = {
      // action triggered on clicking on "view more" button in listing
      // template ajax/t-category.jsp should add html tag with product-related + SELECTORS.trackingPayload data attributes
      loadMore: (payload) => {
        if (payload != null) {
          const products = this.getTrackingPayloadData(payload, true);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          const product = products[0];
          if (typeof product.template !== 'undefined') {
            //track only listing
            if (product.template === "category-page") {
              try {
                this.log("tracking loadMore event with " + products.length + " more products");
                window.listViewMore(products);
              } catch (e) {
                this.log("listViewMore tracking function not available");
              }
            }
          }
        }
      },

      // from category listing or search listin on clicking product box
      productView: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          // looking for first children of [data-tracking-action] el, with [data-tracking-payload] data attribute
          let product = products[0];
          // TODO: add other templates..
          if (typeof product.template !== 'undefined') {
            if ("category-page" === product.template || "na:t-editorial-listing" === product.template || "na:t-editorial" === product.template) {
              try {
                this.log("tracking listProdClick event for product: " + product.id);
                window.listProdClick(product);
              } catch (e) {
                this.warn("listProdClick tracking function not available");
              }
            } else if (product.template === "na:c-recommendation-engine") {
              try {
                this.log("tracking listCarouselClick event for product: " + product.id);
                window.listCarouselClick('recommendation-engine', product);
              } catch (e) {
                this.warn("listCarouselClick tracking function not available");
              }
            } else if ("search-page" === product.template) {
              try {
                this.log("tracking searchProdClick event for product: " + product.id);
                window.searchProdClick(product);
              } catch (e) {
                this.warn("searchProdClick tracking function not available");
              }
            } else {
              try {
                this.log("tracking listProdClick event for product: " + product.id);
                window.listProdClick(product);
              } catch (e) {
                this.warn("listProdClick tracking function not available");
              }
            }
          }
          let algoliaQueryId = document.querySelector('[data-algolia-query-id]')?.dataset?.algoliaQueryId || document.querySelector('[data-algolia-search]')?.dataset?.algoliaSearch;
          if (!algoliaQueryId || algoliaQueryId == "") {
            console.warn("Algolia query ID not found");
          } else{
            // store algolia query id in localStorage before changing page
            storeAlgoliaAttributes();
            // send click event to Algolia
            const position = parseInt(product.position, 10);
            algoliaClickAfterSearch(product, position);
          }
        }
      },

      listCarouselView: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          let product = products[0];
          if (typeof product.template !== 'undefined') {
            if ("na:t-editorial-listing" === product.template ||
              document.querySelector('body').getAttribute('data-controller') === 'EditorialListing') {
              // carousel products in editorial listing are tracked as standard listing
              this.actions.productView(params, el);
            } else {
              let carouselName = "generic";
              try {
                // find carousel name
                let customName = el.closest('[data-id]').dataset.id;
                if (customName !== '' && customName != undefined) {
                  carouselName = customName;
                }
              } catch (e) {
                this.warn('carousel name for listCarouselClick not found, continue..')
              }
              try {
                this.log("tracking listCarouselClick event for product: " + product.id + " in carousel: " + carouselName);
                window.listCarouselClick(carouselName, product);
              } catch (e) {
                this.warn("listCarouselClick tracking function not available");
              }
            }
          }
        }
      },
      lookView: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          let product = products[0];
          try {
            this.log("tracking listCarouselClick event for product: " + product.id);
            window.listCarouselClick('complete-your-outfit', product);
          } catch(e) {
            this.warn("listCarouselClick tracking function not available");
          }
        }
      },
      wishlistAdd: (params) => {
        let productCode = params.code;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('tracking add to wishlist event with code: ' + productCode);
          utag.wishlist_add(productCode);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      //called from AddToCartComponent.js
      addToCart: (params) => {
        let productCode = params.productCode || params;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('tracking add to cart event with code: ' + productCode);
          utag.cart_add(';' + productCode);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
        // algolia tracking
        algoliaAddToCart(productCode);
      },
      removeProduct: (params) => {
        let productCode = params.productCode;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('tracking removeProduct event with productCode: ' + params.productCode);
          utag.cart_remove_click(productCode);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      removeQuantity: (params) => {
        let productCode = params.productCode
        let price = params.price
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        if (typeof price === 'undefined') {
          this.warn('no price found');
          return;
        }
        try {
          this.log('tracking removeQuantity event with productCode: ' + params.productCode);
          utag.cart_minus_click(productCode, 1, price);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      addQuantity: (params) => {
        let productCode = params.productCode
        let price = params.price
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        if (typeof price === 'undefined') {
          this.warn('no price found');
          return;
        }
        try {
          this.log('tracking addQuantity event with productCode: ' + params.productCode);
          utag.cart_plus_click(productCode, 1, price);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      newsletter: (params) => {
        const pos = params.pos;
        const type = params.type ? "-" + params.type : '';
        this.log('[Tracking] NL-Subscription, type: ' + type + ' pos: ' + pos);
        ga('send', 'event', 'NL', 'NL-Subscription' + type, pos);
      },
      formisimo: (params) => {
        this.log("formisimo: ", params);
        if (typeof window.TealiumConversionForm == "function") {
          this.log("TealiumConversionForm: ", params);
          window.TealiumConversionForm(params.formId, params.result);
        } else {
          //keep data in a global var
          window.Tealium.trackingData = {
            formId: params.formId,
            formResult: params.result
          }
        }
      },
      sizeSelection: (params) => {
        let code = params.code;
        if (typeof code === 'undefined') {
          this.warn('no code found');
          return;
        }
        try {
          this.log('tracking sizeSelection event with code: ' + code);
          utag.size_selection();
          let mainSizeRow = document.querySelector('.c-sizes-row');
          mainSizeRow.dataset.errorMessage = '';
        } catch (e) {
          this.warn('Utag tracking is not available');
        }
      },
      O2OCCSelect: (params) => {
        if (!this.isCartPage()) {
          return;
        }
        try {
          this.log('tracking 020 CC selected event');
          utag.click_collect('click');
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCSearch: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        let o2oCCSearchInput = $(this.SELECTORS.O2OCCSearchInput).val();
        try {
          this.log('tracking 020 CC store search event: ' + o2oCCSearchInput);
          utag.click_collect(o2oCCSearchInput);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCLocalize: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        try {
          this.log('tracking 020 CC localize event');
          utag.click_collect('localizza');
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCSelectStore: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        let storeName = params.storeName;
        if (typeof storeName === 'undefined') {
          this.warn('no storeName found');
          return;
        }
        try {
          this.log('tracking 020 CC store select event: ' + storeName);
          utag.click_collect("store:" + storeName);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      //called from FiltersComponent.js
      filterTracking: (params, orderBy) => {
        let facetCode = $(params).attr("data-facet-code");
        let facetValue = $(params).attr("data-code");
        let facetV = undefined;
        this.log("Triggering filter");
        if (orderBy === true) {
          facetCode = "orderBy";
          facetValue = $(params).attr("data-sortby-name");
          facetV = $(params).attr("value");
          let sorting_method = "";
          if(facetV.includes("rank")){
            sorting_method = "t2s_sorting";
          } else if (facetV.includes('personalization')){
            sorting_method = "algolia_sorting";
          }
          else {
            sorting_method = "solr_sorting";
          }
          utag_data['sorting_type'] = this.getSortTypeTracking(facetV);
          utag_data['sorting_method'] = sorting_method;

          try {
            let container = document.querySelector('.c-l__products.js-filters-result');
            if (container) {
              if (sorting_method !== "algolia_sorting") {
                let qid = container.getAttribute('data-algolia-query-id') || '';
                let idx = container.getAttribute('data-algolia-index') || '';
                if (qid) {
                  try {
                    localStorage.setItem('algoliaQueryId', qid);
                    localStorage.setItem('algoliaIndex', idx);
                  } catch(e) {}
                }
                container.setAttribute('data-algolia-query-id', '');
                container.setAttribute('data-algolia-index', '');
              } else {
                let qid =
                  document.querySelector('[data-algolia-query-id]')?.dataset?.algoliaQueryId ||
                  document.querySelector('[data-algolia-search]')?.dataset?.algoliaSearch ||
                  localStorage.getItem('algoliaQueryId') || '';
                let idx =
                  document.querySelector('[data-algolia-index]')?.dataset?.algoliaIndex ||
                  localStorage.getItem('algoliaIndex') || '';
                if (qid) container.setAttribute('data-algolia-query-id', qid);
                if (idx) container.setAttribute('data-algolia-index', idx);
              }
            }
          } catch(e) {}

          this.log("Triggering filter sort " + facetCode + ": " + facetValue);
          utag.link({
            filter: facetCode + ":" + facetValue,
            event_name: "filter_usage",
            sorting_method: sorting_method,
            sorting_type: this.getSortTypeTracking(facetV)
          });
        }

        if(facetValue != null && !orderBy) {
          this.log("Triggering filter" + facetCode + ": " + facetValue);
          try {
            this.log('tracking link event: ' + facetValue);
            utag.link({
              filter: facetCode + ":" + facetValue,
              event_name: "filter_usage",
            });
          } catch(e) {
            this.warn("Utag tracking not available");
          }
        }
      },
      startChat: () => {
        utag.link({
          event_name: "chat_start"
        });
      },
      deleteChat: () => {
        utag.link({
          event_name: "chat_delete"
        });
      },
      addCartGiftCard: (params) => {
        utag.link({
          event_category: "gift card",
          event_action: "add to cart",
          event_label: "giftcart " + params,
          event_name: "giftcart_add_to_cart"
        });
      },
      newsletterSubscribe: (params) => {
        let position = params.trackingPosition;
        utag.link({
          event_name: "newsletter_subscribe",
          event_location: position
        });
      },
      signup: (country) => {
        utag.link({
          event_name: "sign_up",
          event_method: "manual",
          store_country: country,
        })
      },
      whatsappStart: () => {
        utag.link({
          event_name: "whatsapp_start"
        });
      },
      shortcutCategoryView: (params) => {
        try {
          this.log('Tracking shortcut category click: ' + params.shortcutLabel);
          var data = new Object();
          data['event_name'] = 'select_content';
          data['event_location'] = params.shortcutNumber// es. shortcut-micro_1, shortcut-macro_4 …
          data['event_detail'] = params.shortcutLabel// es. our selection, clothing, pantaloni, abiti, …
          data['content_type'] = params.shortcutType// es. shortcut-micro, shortcut-macro…
          utag.link(data)
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
    }
  }
  isCartPage() {
    let element = $(this.SELECTORS.cartPage);
    if (element.length > 0) {
      return true;
    }
    return false;
  }

  isLogged() {
    const locationPath = window.location + "";
    return locationPath.split("/")[3].split("?")[1] === "login=success";
  }

  getListString(codeList) {
    let listString = ";";

    $.each(codeList, function (index, value) {
      listString += value + ",;";
    });

    listString = listString.substr(0, listString.lastIndexOf(","));
    return listString;
  }

  carouselOnLoad() {
    // find and track generic carousels
    // (recommendation tracked by custom event because async)

    // avoid tracking of carousels in editorial listing
    if (document.querySelector('body').getAttribute('data-controller') !== 'EditorialListing') {
      document.querySelectorAll('.w-p-carousel__items:not([data-id="' +
        this.SELECTORS.recommendationEngineCarouselId + '"])').forEach((carousel) => {
        if (carousel == null) {
          this.log('carousel not found');
          return;
        }
        this.trackCarousel(carousel);
      });
    }
    //tracks "complete-the-look" carousel in PdP
    if (document.querySelector('body').getAttribute('data-controller') === 'Product') {
      let lookCarousel = document.querySelector('#complete-your-outfit');
      if (lookCarousel == null) {
        this.log('"complete-the-look" carousel not found');
        return;
      }
      this.trackCarousel(lookCarousel, true);
    }
  }

  trackCarousel(carousel, isLook = false) {
    let carouselName;
    try {
      carouselName = carousel.dataset.id;
    } catch (e) { // data-id is missing
    }
    //fallback in case of empty name
    if (carouselName === '' || carouselName === undefined) {
      carouselName = 'generic';
    }
    try {
      if (isLook) {
        //check view, find appropriate parent
        if (Matchmq('767','0' )===true) {
          carousel = carousel.getElementsByClassName('cyo__mobile')[0];
        } else {
          carousel = carousel.getElementsByClassName('cyo__desktop')[0];
        }
      }
      let products = this.getTrackingPayloadData(carousel.children, true);
      if (products.length == 0 || typeof products === 'undefined') {
        this.log("no products found in " + carouselName + " carousel");
        return;
      }
      try {
        this.log("tracking '" + carouselName + "' carousel with " + products.length + " products");
        window.listCarouselImpression(carouselName, products);
      } catch (e) {
        this.warn("listCarouselImpression tracking not available");
      }
    } catch (e) {
      this.warn('carousel tracking not available');
    }
  }

  trackAction(action, data, targetElement) {
    if (this.actions[action]) {
      if (typeof data['bs.tab'] != 'undefined') {
        delete data['bs.tab'];
      }
      this.log('[Tracking] tracking action caught: ' + action + ' - with params: ' + JSON.stringify(data));
      this.actions[action](data, targetElement);
    } else {
      this.warn('[Tracking] no tracking manager found for action ' + action);
    }
  }

  bindEvents() {
    this.$on('click', ({event}) => {
      if (!$(event.currentTarget).data('disabled') && $(event.currentTarget).data('trackingAction')) {
        let data = $(event.currentTarget).data();
        let action = data.trackingAction;
        this.trackAction(action, data, event.target);
      }
    }, 'body', this.SELECTORS.dataTracking);

    if (this.isLogged()) {
      this.trackAction('login');
    }
  }

  bindCustomEvents() {
    // ??? custom "track" events
    $('body').on('track', (e, action, params) => {
      const data = [].slice.call(arguments).splice(2);
      this.trackAction(action, data);
    });

    // tracking loadMore button (not used)
    //this.$on(this.$customEvents.TRACKING.loadMore, (e) => {
    //  this.log("emitting tacking event: " + this.$customEvents.TRACKING.loadMore);
    //  this.actions["loadMore"](e.payload);
    //});

    // track recommendation carousel async
    this.$on(this.$customEvents.RECOMMENDATION_EVENTS.loaded, ({payload}) => {
      // google rec, next iteration is to adapt all carousel to follow the payload pattern
      if(payload) {
        if(payload.carouselType && payload.carouselType === "googleRecommendation") {
          const products = this.getTrackingPayloadData(payload.carousel.$component, true);
          if(products && products.length > 0) {
            try {
              this.log("Tracking listCarouselImpression on", payload.carouselTitle);
              window.listCarouselImpression(payload.carouselTitle, products);
            } catch(error) {
              this.warn("listCarouselImpression tracking not available");
            }
            const productCards = payload.carousel.$component.querySelectorAll("[data-product-card]")
            if(productCards && productCards.length > 0) {
              productCards.forEach(productCard => {
                productCard.addEventListener("click", event => {
                  const dataTracking = event.currentTarget.querySelector(this.SELECTORS.trackingPayload);
                  try {
                    this.log("tracking listCarouselClick event for product: " + dataTracking.dataset.id);
                    window.listCarouselClick(dataTracking.dataset.parentName, dataTracking.dataset);
                  } catch(e) {
                    this.warn("listCarouselClick tracking function not available");
                  }
                });
              });
            }
          }
        }
      } else {
        let recommendationCarousel = document.querySelector('.w-p-carousel__items[data-id="' +
          this.SELECTORS.recommendationEngineCarouselId + '"]');
        if (recommendationCarousel != null) {
          this.trackCarousel(recommendationCarousel)
        }
      }
    });
  }

  initiateTracking() {
    const ctx = this;
    const $formisimo = $('formisimo');
    window.Tealium = {};

    if ($formisimo.length > 0) {
      $formisimo.each(function () {
        const $this = $(this);
        const data = [{'formId': $this.data('formId'), 'result': $this.data('formResult')}];
        ctx.trackAction('formisimo', data);
      });
    }
  }

  render() {
    this.initiateTracking();
    this.bindEvents();
    this.bindCustomEvents();
    window.addEventListener('load', (event) => {
      this.carouselOnLoad();
    });
  }
}
